import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';

import { removeUserFailed, removeUserSuccessful } from '../actions';
import { OK } from '../../../configs/serverStatusCodes';
import makeRequest from '../../../utils/makeRequest';
import processError from '../../../utils/processError';

export default function* removeUser(action) {
  try {
    const {
      name = '',
      display_name = '',
      id,
    } = action.payload;
    const url = `${BACKEND_URL}/roles/${id}`;
    const pool = {
      name,
      display_name,
    };
    const dataResponse = yield makeRequest(url, pool, action, 'DELETE', true);
    const data = yield dataResponse.json();

    if (dataResponse.status === OK
      && data
    ) {
      yield put(removeUserSuccessful([]));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(removeUserFailed([]));
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(removeUserFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
